import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('channels', storeModule.createStoreModule('channels'))
